import { AfterViewInit, Component, ViewChild, OnInit, Renderer2, OnDestroy } from "@angular/core";
import { ApiService } from "./api.service";
import { PlatformLocation } from "@angular/common";
import { Subscription } from 'rxjs/Subscription';
import { WeChatConfig } from "./wechatconfig";
import {
  Router,
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
  ActivatedRoute,
} from "@angular/router";
import { TokenService } from "./tokenService.service";
import { CommonService } from "./common.service";
import { StoreService } from "./store.service";
import {ComponentMenuBar} from '../component-ui/menu-bar/component';

// declare var Tongji: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('menuBar')
  menuBar: ComponentMenuBar;
  notAuthedSubscription: Subscription;
  mentorEnteredSubscription: Subscription;
  title = "test app";
  assetsRoute: string = "../assets"
  pageLoaded = false;
  loading = false;
  showMenuBar: boolean = false;
  previousUrl: string;
  browserPlatformLocation: string; //browserPlatformLocation
  testEnvironment: any = ["ttt.chinaeast2.cloudapp.chinacloudapi.cn"];
  isStartHeatBeat: boolean = false;
  //停止心跳url列表
  stopBeatingList: any = ["/new-login", "/course-new","/course-select"];
  isShowTip: boolean = false;
  startAsking:boolean = false;
  channel: string = ""; //渠道
  gdprStatus: string = "";
  isShowGDPR: boolean = false;
  learningPathMetaId: any;
  campId: any;
  exerciseBook:any;
  isHaveTools: boolean = false;
  loadFinished: boolean = false;
  isShowGuide: boolean = false;
  isShowMentorGuide: boolean = false;
  showMentorRedDot: boolean = false;
  isOnlyCamp: boolean = false;
  userAuthority: any;//用户权限

  //停止当前登录有效与否轮询列表
  constructor(
    private apiService: ApiService,
    private commonService: CommonService,
    private tokenService: TokenService,
    private route: ActivatedRoute,
    private platformLocation: PlatformLocation,
    private router: Router,
    private storeService:StoreService,
    private renderer: Renderer2
  ) {
    router.events.subscribe((event: RouterEvent) => {
      // var Tongji = window['Tongji'];
      this.navigationInterceptor(event);
      // Tongji.visitPage(this.router.url, this.previousUrl);
    });
  }

  async ngOnInit() {
    // 检测鸿蒙系统并添加全局CSS类，修复字体大小问题
    if (this.commonService.isHarmonyOS()) {
      this.renderer.addClass(document.body, 'harmonyos-browser');
      console.log('检测到鸿蒙浏览器，已应用字体修复样式');
    }
    
    await this.tokenService.setTokenAndUserId();
    this.setChannelHandle();
    this.browserPlatformLocation = this.platformLocation["location"];
    this.pageLoaded = true;
    this.commonService.getIsSpecialLink('isShowBack', this.browserPlatformLocation['href'], 'openClass',1);
    this.commonService.getIsSpecialLink('PC',this.browserPlatformLocation['href'], 'isPC',1);
    this.commonService.getIsSpecialLink('isIframe',this.browserPlatformLocation['href'], 'isIframe',1);
    this.commonService.getIsSpecialLink('practiceIndex',this.browserPlatformLocation['href'], 'practiceIndex',this.commonService.getQueryString('practiceIndex'));

    if (
      typeof WeixinJSBridge == "object" &&
      typeof WeixinJSBridge.invoke == "function"
    ) {
      handleFontSize();
    } else {
      if (document.addEventListener) {
        document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
      }
    }
    function handleFontSize() {
      WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      WeixinJSBridge.on("menu:setfont", function () {
        WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
        WeixinJSBridge.call("hideToolbar");
      });
    }
    window.addEventListener(
      "popstate",
      function (e) {
        e.preventDefault();
        $("body").css("height", "100%");
      },
      false
    );
    // 全局监听 notAuthed，修复重复订阅问题
    this.notAuthedSubscription = this.storeService.notification.notAuthed.subscribe(d => {
      if (d === true) {
        // 如果当前页面在黑名单中（如登录页），则忽略
        if (this.ifStopExecuteUserAsking(this.router.url)) {
          return;
        }
        console.log('接口未授权,在其他地方登录-----', d);
        this.postParentWindowLoginOut();
        this.startAsking = true;
      }
    });
    this.mentorEnteredSubscription = this.storeService.notification.mentorEntered.subscribe(value => {
      if (value === true && !this.commonService.isMentorGuideDebugMode()) {
        this.showMentorRedDot = false;
      }
    });
  }

  ngAfterViewInit() {
    this.commonService.initPage();
    this.postParentWindowLoaded();
  }


  getUserCampInfo(){
    //获取训练营
    this.getUserExerciseBookAPI(0, 0).then(result => {
      this.exerciseBook = result;
    }).then(()=>{
      this.loadFinished = true;
    })
  }




  //获取用户所有训练营下面的练习册
  getUserExerciseBookAPI(campId: any,status: number):Promise<any>{
    return this.apiService.ajax({
      'type': 'GET',
      'url': 'ddilearner/v2/camp/applicationPractice/exerciseBook?campMetasId=' + campId + '&status=' + status
    }).toPromise();
  }

  getUserAuthority():void{
    this.commonService.getUserCheckAuthority().then(result=>{
      console.log('用户权限返回',result);
      this.userAuthority = result;
      this.isHaveTools = this.commonService.hasToolsAuthority(result);
      this.commonService.setStorage('isHaveTools', JSON.stringify(this.isHaveTools));
      this.updateMentorGuideState();
      if (this.isHaveTools) {
        this.commonService.getOnceIno(99999).then(guideResult => {
          this.isShowGuide = guideResult !== 1;
        });
      }
    })
  }

  updateMentorGuideState(): void {
    if (!this.commonService.hasLeaderCoachAuthority(this.userAuthority)) {
      this.isShowMentorGuide = false;
      this.showMentorRedDot = false;
      return;
    }
    if (this.commonService.isMentorGuideDebugMode()) {
      this.isShowMentorGuide = true;
      this.showMentorRedDot = true;
      return;
    }
    // 本地已标记进过导师时先消红点，避免外链返回/页面优化返回时接口尚未同步
    if (this.commonService.hasMentorEnteredLocal()) {
      this.showMentorRedDot = false;
    }
    Promise.all([
      this.commonService.getOnceIno(this.commonService.MENTOR_GUIDE_ONCE_VALUE),
      this.commonService.getOnceIno(this.commonService.MENTOR_ENTERED_ONCE_VALUE)
    ]).then(([guideResult, enteredResult]) => {
      this.isShowMentorGuide = guideResult !== 1;
      const entered = enteredResult === 1 || this.commonService.hasMentorEnteredLocal();
      this.showMentorRedDot = !entered;
      if (enteredResult === 1) {
        this.commonService.markMentorEnteredLocal();
      } else if (!entered) {
        // 重置上一账号残留的 BehaviorSubject(true)，否则新账号菜单会误判已进过导师
        this.storeService.notification.mentorEntered.next(null);
      }
    });
  }

  applyMentorGuideDebugState(url: string): void {
    if (!this.commonService.isMentorGuideDebugMode()) {
      return;
    }
    if (!this.ifShowMenubarByUrl(url)) {
      return;
    }
    if (!this.commonService.hasLeaderCoachAuthority(this.userAuthority)) {
      return;
    }
    this.isShowMentorGuide = true;
    this.showMentorRedDot = true;
  }


  //设置渠道操作
  setChannelHandle(){
    this.channel = window.location.href.indexOf('yyddi') !== -1 ? 'yyddi' : '';
    let learning_remind_recall = window.location.href.indexOf('learning_remind_recall') !== -1;
    let graduation_remind_recall = window.location.href.indexOf('graduation_remind_recall') !== -1;
    let ability_open_recall = window.location.href.indexOf('ability_open_recall') !== -1;
    if(learning_remind_recall){
      this.commonService.learningPortEventLog({
        "eventType" : "learning_remind_recall",
        "eventSubType" : ""
      }).then()
    }

    if(graduation_remind_recall){
      this.commonService.learningPortEventLog({
        "eventType" : "graduation_remind_recall",
        "eventSubType" : ""
      }).then()
    }

    if(ability_open_recall){
      this.commonService.learningPortEventLog({
        "eventType" : "ability_open_recall",
        "eventSubType" : ""
      }).then()
    }

    const resource_route = {
      'yyddi':'/yyddi/'
    }[this.channel]||'/';
    let target = document.getElementById('resource_route');
    this.renderer.setAttribute(target,'href', resource_route);
    this.renderer.setAttribute(target,'data-src', '');
    if(this.channel === 'yyddi'){
      this.renderer.setAttribute(target,'data-src', 'assets');
      this.assetsRoute = "assets";
    }
  }

  // 显示提示框
  showComponentTip(){
    this.isShowTip = true;
  }

  // 关闭提示框
  closeComponentTip(){
    this.isShowTip = false;
    this.menuBar.showOrCloseFullPage();
  }

  //关闭GDPR
  closeGDPR(){
    this.isShowGDPR = false;
    this.gdprStatus = "";
    setTimeout(()=>{
      this.menuBar.showOrCloseFullPage();
    },100);
  }

  //显示GDPR
  showGDPR(){
    this.isShowGDPR = true;
    setTimeout(()=>{
      this.gdprStatus = "open";
    },100);
  }

  // 登出
  logout(){
    this.apiService.logout().subscribe(res => {
      if(res){
        console.log(res,'登出接口');
        this.isShowTip = false;
        this.isStartHeatBeat = false;
        sessionStorage.removeItem('userSession');
        //清除多公司记录
        this.commonService.clearLoginCredentials();
        this.commonService.removeStorage('themeBG');
        this.commonService.clearMentorEnteredLocal();
        this.storeService.notification.mentorEntered.next(null);
        this.commonService.removeStorage('userId');
        this.commonService.removeStorage('transtalen-token');
        this.commonService.removeStorage('transtalenuserid');
        this.router.navigate(['new-login']);
      }
    })
  }

  weixinLogin() {
    if (location.pathname != "/") {
      if (window.location.href.indexOf("#wechat_login") == -1) {
        this.pageLoaded = false;
        var domain = window.location.hostname;
        var referUrl = encodeURIComponent(window.location.href);
        var url = "/api/login?domain=" + domain + "&referUrl=" + referUrl;
        window.location.href = url;
      } else {
        if (window.location.href.indexOf("?") > 0) {
          window.location.href =
            window.location.href.split("?")[0] + "#wechat_login";
        } else {
          this.pageLoaded = true;
        }
      }
    }
  }

  configWeixin() {
    var data = {
      pageUrl: encodeURIComponent(window.location.href.split("#")[0]),
    };
    this.apiService.getWechatConfig(data).subscribe((result) => {
      wx.config({
        debug: false, //开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: result.appId, //公众号的唯一标识
        timestamp: result.timestamp, //生成签名的时间戳
        nonceStr: result.nonceStr, //生成签名的随机串
        signature: result.signature, //签名
        jsApiList: [
          "onMenuShareAppMessage",
          "onMenuShareTimeline",
          "hideAllNonBaseMenuItem",
          "showAllNonBaseMenuItem",
        ],
      });

      wx.ready(function () {
        wx.hideAllNonBaseMenuItem();
      });
    });
  }
  ifShowMenubarByUrl(originUrl){
    let showMenuBarList :Array<string> = [
      '/learning-map'
    ]
    return !!(showMenuBarList.find(url => originUrl.indexOf(url) > -1))
  }
  ifStopExecuteUserAsking(originUrl){
    let stopAskingList:Array<string> = [
      '/new-login',
      '/course-select'
    ];
    return !!(stopAskingList.find(url => originUrl.indexOf(url) > -1))
  }
  navigationInterceptor(event: RouterEvent) {
    if (event instanceof NavigationStart) {
      console.log(event.url);
      if(event.url.split("source_env=")[1] === "LMS_SCORM"){
        localStorage.setItem("source_env","LMS_SCORM");
      }

      if(this.platformLocation['location']['protocol'].indexOf('https') > -1){
        //路由跳转时获取版本信息进行对比处理
        this.apiService.getVersionData().subscribe((res) => {
          console.log('message:获取版本信息', res);
          this.commonService.versionExamine(res.version);
        });
      }

      //处理全局menuBar
      if(this.ifShowMenubarByUrl(event.url)){
        //外链或者不需要显示菜单栏的地址
        this.showMenuBar = true;
        this.getUserCampInfo();
        this.isOnlyCamp = !!this.commonService.getStorage('onlyCamp');
        this.getUserAuthority();
      }else{
        this.showMenuBar = false;
      }
      if(this.stopBeatingList.every(itemUrl => event.url.indexOf(itemUrl) === -1)){
        this.isStartHeatBeat = true;
        console.log("message:启动heartbeat系统！");
      }else{
        this.isStartHeatBeat = false;
        console.log("message:当前页面不需要启动heartbeat系统！");
      }
      // 处理轮询
      if(this.ifStopExecuteUserAsking(event.url)){
        console.log('message---停止轮询')
        this.startAsking = false;
      }else{
        //启用轮询的页面
        //判断当前用户是否渠道身份
        this.storeService.notification.isChannel.subscribe(d=>{
          // d can be null(initial value)、true and false.
          if(d === true){
            //渠道用户
            console.log('message---关闭轮询')
            this.startAsking = false;
          }else if(d === false){
            //非渠道身份
            console.log('message---开启轮询')
            this.startAsking = true;
          }
        })

      }
    }

    if (event instanceof NavigationEnd) {
      console.log(event.url);
      if(this.commonService.getStorage('userId')){
        gaGtag('set', {'user_id': `${this.commonService.getStorage('userId')}`})
        gaGtag('set', 'page_path', event.url);
        gaGtag('event', 'page_view');
      }
      this.loading = false;
      this.previousUrl = event.url;
      this.applyMentorGuideDebugState(event.url);
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loading = false;
    }
    if (event instanceof NavigationError) {
      this.loading = false;
    }
  }
  //告诉父窗口登录失效：第三方对接
  postParentWindowLoginOut() {
    console.log('postParentWindowLoginOut')
    window.parent.postMessage({
      action: 'sessionExpiredConfirmed',
      vendor: 'DDI',
      params: {}
    },'*');
  }

  //告诉父窗口加载完成：第三方对接
  postParentWindowLoaded() {
    console.log('postParentWindowLoaded')
    window.parent.postMessage({
      action: 'iframeLoaded',
      vendor: 'DDI',
      params: {}
    },'*');
  }

  /**
   * 进入工具
   */
  goTools():void{
    this.isShowGuide = false;
    this.menuBar.goTools();
  }

  onMentorMenuClick(): void {
    this.isShowMentorGuide = false;
    // 引导关闭后立刻恢复红点/NEW（未进过导师时）；避免被 !isShowMentorGuide 遮罩后状态不同步
    if (!this.commonService.isMentorGuideDebugMode()) {
      const entered = this.commonService.hasMentorEnteredLocal();
      this.showMentorRedDot = !entered;
      if (this.menuBar) {
        this.menuBar.syncMentorBadgeAfterGuide(!entered);
      }
    }
    if (this.menuBar) {
      this.menuBar.showOrCloseFullPage();
    }
  }

  onMenuBarCloseDuringDebug(): void {
    this.applyMentorGuideDebugState(this.router.url);
  }

  onMentorEntered(): void {
    if (this.commonService.isMentorGuideDebugMode()) {
      return;
    }
    this.commonService.markMentorEnteredLocal();
    this.showMentorRedDot = false;
  }

  isWeixinBrowser() {
    var ua = navigator.userAgent.toLowerCase();
    var isWeixin = ua.indexOf("micromessenger") != -1;
    return isWeixin;
  }

  getHeartBeatStatusByAsking(event) {
    this.isStartHeatBeat = event;
  }

  ngOnDestroy() {
    if (this.notAuthedSubscription) {
      this.notAuthedSubscription.unsubscribe();
    }
    if (this.mentorEnteredSubscription) {
      this.mentorEnteredSubscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts